import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { from, map } from 'rxjs';
import { MetaTagsService, MetaTags } from '@mode/shared/util-js';
import { ApiService } from '@mode/shared/util-halogen';
import { toSchedule } from './report-schedules.mapper';
import { ReportScheduleResource, ReportSchedulesResource } from '@mode/shared/schedules/contract';
@Injectable({
  providedIn: 'root',
})
export class ReportScheduleClientService {
  constructor(
    private metaTagService: MetaTagsService,
    private apiService: ApiService,
    private http: HttpClient
  ) {}

  private getOrg() {
    return this.metaTagService.getTag(MetaTags.OwnerUsername);
  }

  public loadSchedules(reportId: string) {
    const url = `/api/${this.getOrg()}/reports/${reportId}/schedules`;
    return from(
      this.apiService.getFromPath<ReportSchedulesResource>(url, {
        includes: {
          report_schedules: {
            report_subscriptions: {
              report_subscriptions: [
                'new_email_subscription_membership',
                'slack_subscription_memberships',
                'new_slack_subscription_membership',
                'email_subscription_memberships',
              ],
            },
          },
        },
      })
    ).pipe(
      map((response) =>
        (response?._embedded?.['report_schedules'] ?? []).map((reportSchedule: ReportScheduleResource) =>
          toSchedule(reportSchedule)
        )
      )
    );
  }

  public createEmailSubscription(url: string, emailPayload: { membership: { subscriber_email: string } }) {
    return this.http.post(url, emailPayload).pipe(
      map((response: any) => ({
        id: response?._links?.report_subscription?.href,
        email: response?.email,
        deleteUrl: response?._forms?.destroy?.action,
      }))
    );
  }

  public deleteSchedule(reportId: string, scheduleId: string) {
    const url = `/api/${this.getOrg()}/reports/${reportId}/schedules/${scheduleId}`;

    return this.http.delete(url);
  }

  public deleteEmailSubscription(url: string) {
    return this.http.delete(url);
  }
}
